import React from 'react';
import { Phone, ArrowUpRight } from 'lucide-react';
import { COMPANY } from '../../mock';

export default function ContactCTA({ onQuote }) {
  return (
    <section id="contact" className="py-20 md:py-28 bg-white">
      <div className="egea-container">
        <div className="relative overflow-hidden bg-[#f5a524] px-8 py-14 md:px-16 md:py-20">
          <div className="relative max-w-[640px]">
            <span className="text-[12px] font-bold uppercase tracking-[0.22em] text-slate-900/70">
              Începe proiectul tău
            </span>
            <h2 className="font-display font-black uppercase tracking-tight text-slate-900 text-3xl md:text-5xl leading-[1] mt-4">
              Cere o ofertă tehnică în 24h
            </h2>
            <p className="mt-5 text-base md:text-lg text-slate-900/80 max-w-[520px] leading-relaxed">
              Trimite câteva detalii și primești un deviz cu specificații și termen de livrare
              într-o zi lucrătoare. Fără call-back pe care nu-l ceri.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button
                onClick={onQuote}
                data-testid="cta-quote-btn"
                className="bg-slate-900 text-white font-bold uppercase text-sm tracking-wide px-8 py-4 hover:bg-slate-800 transition-colors inline-flex items-center gap-2"
              >
                Cere ofertă <ArrowUpRight size={18} />
              </button>
              <a
                href={COMPANY.phoneHref}
                className="border-2 border-slate-900 text-slate-900 font-bold uppercase text-sm tracking-wide px-8 py-4 hover:bg-slate-900 hover:text-white transition-colors inline-flex items-center gap-2"
              >
                <Phone size={16} /> {COMPANY.phone}
              </a>
            </div>
            <p className="mt-6 text-[13px] text-slate-900/70">Răspuns &lt; 24h · {COMPANY.location}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
